import Vue from 'vue'
import App from './App'
import moment from 'moment'
import router from './router.js'
import store from './store.js'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import { dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome/index'

// for wistia embed
import VueHead from 'vue-head'

import VueAnalytics from 'vue-analytics'

//import FontAwesomeIcon from './modules/fontawesome.js';
Vue.component('font-awesome-icon', FontAwesomeIcon)

// look for font awesome tags and replace with svg.
dom.watch()

Vue.use(VueHead)

Vue.use(VueAnalytics, {
    appName: 'router',
    appVersion: '0.5',
    id: 'UA-46254286-1',
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    debug: true, // @todo set to false
    trackPage: true, // @todo set to true
    autoTracking: {
        exception: true,
        exceptionLogs: true,
    },
})

// moment.js
Object.defineProperty(Vue.prototype, 'moment', { value: moment })
moment.locale('NL')

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})
